import Strings from './Strings';

export { Strings };
